module.exports = __webpack_public_path__ + "media/images/career_camp/2023/perks_2-71d5c66c9815790f36baad043d765210.svg";